// apps/app/src/features/billing/waiting-for-owner.tsx
//
// What a clinic's team sees until the owner has started the free trial (only
// the owner can choose a plan and add a card). Small and eagerly loaded: it is
// rendered by the router's TrialGate.

import { useTranslation } from 'react-i18next';
import { CreditCard, LogOut } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { useAuth } from '@/lib/auth';

/** For everyone in the clinic except the owner, until the owner starts the trial. */
export function WaitingForOwner() {
  const { t } = useTranslation('billing');
  const logout = useAuth((s) => s.logout);
  return (
    <div className="mx-auto max-w-md py-16">
      <Card className="p-8 text-center">
        <span className="mx-auto grid size-12 place-items-center rounded-full bg-muted">
          <CreditCard className="size-5 text-muted-foreground" aria-hidden="true" />
        </span>
        <h1 className="mt-4 text-lg font-semibold">{t('startTrial.waiting.title')}</h1>
        <p className="mt-2 text-sm text-muted-foreground">{t('startTrial.waiting.body')}</p>
        <Button variant="outline" className="mt-6" onClick={() => void logout()}>
          <LogOut aria-hidden="true" />
          {t('startTrial.waiting.signOut')}
        </Button>
      </Card>
    </div>
  );
}
